module.exports = __webpack_public_path__ + "img/disableADA.39206119.png";